import { render } from "./table-cell-boolean.vue?vue&type=template&id=279587c8"
import script from "./table-cell-boolean.vue?vue&type=script&lang=js"
export * from "./table-cell-boolean.vue?vue&type=script&lang=js"

import "./table-cell-boolean.vue?vue&type=style&index=0&id=279587c8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__